import { ComponentStates } from '../../types/ComponentStates.types';

const getInputState = (error?: string | null) => {
  return !!error ? ComponentStates.ERROR : ComponentStates.DEFAULT;
};

export default getInputState;
